import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { connect } from 'react-redux'

import { guessVars } from '../../actions/states/new/setupVars'

class PricingGrid extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedTab: null,
      swipeEligible: false
    }
    this.setOptionAndRedirect = this.setOptionAndRedirect.bind(this)
  }

  setOptionAndRedirect(optionId) {
    return e => {
      e.preventDefault()
      const preselected = {}

      preselected[optionId] = true
      //this.props.dispatch(preselectOption("interested_in", preselected))
      const browserHistory = useHistory()

      browserHistory.push(
        `${
          this.props.match.params.state ? `/${this.props.match.params.state}` : ''
        }/quote`
      )
    }
  }

  componentDidMount() {
    switch (this.props.location.pageId) {
      case 'group':
        this.setState({ ...this.state, selectedTab: 2 })
        break
      case 'individual':
        this.setState({ ...this.state, selectedTab: 1 })
        break
      default:
        this.setState({ ...this.state, selectedTab: null })
    }
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    if (nextProps.location.pageId !== this.props.location.pageId) {
      console.log(nextProps.location.pageId)

      switch (nextProps.location.pageId) {
        case 'group':
          this.setState({
            ...this.state,
            selectedTab: 2,
            swipeEligible: !!this.state.selectedTab
          })
          break
        case 'individual':
          this.setState({
            ...this.state,
            selectedTab: 1,
            swipeEligible: !!this.state.selectedTab
          })
          break
        default:
          this.setState({ ...this.state, selectedTab: null, swipeEligible: false })
      }
    }
  }

  selectTab = tabId => {
    this.setState({
      ...this.state,
      selectedTab: tabId
    })
  }

  btnText = (dfltText = 'Get a Quote') => {
    return [
      <span className="hidden-xs">{dfltText}</span>,
      <span className="visible-xs">Go</span>
    ]
  }

  render() {
    const props = this.props
    const variableArray = guessVars(this.props.match.params.state)
    const siteUrl = variableArray.appUrl

    console.log(props, this.state)

    return (
      <div>
        <div className="container">
          <h2 className="page-title">Upgrades and Pricing</h2>
        </div>
        <div
          className={`section title-block-bar pricing-section`}
          style={{
            backgroundColor: '#80bc00',
            paddingTop: '60px',
            paddingBottom: '60px'
          }}>
          <div className="container">
            <h3 style={{ color: 'white', textAlign: 'center' }}>
              <b>Choose the Option that Best Suits You</b>
            </h3>
            <p style={{ fontSize: '1.1rem' }}>
              The Headed2 Career Explorer offers several options from which to choose.
              From a free account for educators to district wide deployments, there is an
              account type or upgrade to suit your needs.
            </p>
          </div>
        </div>

        <div className="container" style={{ marginBottom: '25px', position: 'relative' }}>
          <div key="individual-pricing-items">
            <div className="row" style={{ marginTop: '30px' }}>
              <table className="ind-feature-table">
                <colgroup>
                  <col></col>
                  <col span="2" style={{ backgroundColor: '#fef8e4' }}></col>
                  <col span="2" style={{ backgroundColor: '#eef6fb' }}></col>
                </colgroup>
                <thead>
                  <tr>
                    <th></th>
                    <th colSpan="2" style={{ backgroundColor: '#fff', padding: '0' }}>
                      <div className="h2account h2account-educator">
                        <div className="graphic-top"></div>
                        <div className="content">
                          <h3>Individual Educators</h3>
                          <hr />

                          <div className="description">
                            Ideal for educators who need more from their Headed2 Account,
                            so they can use it with their students in the classroom.
                          </div>
                        </div>
                      </div>
                    </th>
                    <th colSpan="2" style={{ backgroundColor: '#fff', padding: '0' }}>
                      <div className="h2account h2account-premium">
                        <div className="graphic-top"></div>
                        <div className="content">
                          <h3>Groups, Schools, and Organizations</h3>
                          <hr />

                          <div className="description">
                            Designed for educators who need even more functionality or who
                            need to collaborate with other educators.
                          </div>
                        </div>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th
                      className=""
                      style={{ width: '20%', padding: 0, verticalAlign: 'bottom' }}>
                      Features
                    </th>
                    <th className="basic-account text-center " style={{ width: '20%' }}>
                      Free Educator Account
                    </th>
                    <th className="ed-account text-center" style={{ width: '20%' }}>
                      Premium Educator Account
                    </th>
                    <th className="prem-ed-account text-center" style={{ width: '20%' }}>
                      Basic Upgrade
                    </th>
                    <th className="prem-ed-account text-center" style={{ width: '20%' }}>
                      Enhanced Upgrade
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Students Under Management</td>
                    <td className="ed-account feature-exists">
                      Up to {variableArray.freeEducatorAccountQuota}
                    </td>
                    <td className="feature-exists">Up to 175</td>
                    <td className="feature-exists">As Required</td>
                    <td className="feature-exists">As Required</td>
                  </tr>
                  <tr>
                    <td>Basic Reporting</td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Assignable Lesson Plans</td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Turnkey Curriculum</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>File Management</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Integrated Course Planner</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Up The Ladder</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Student Groups</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i>coming soon</i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Multiple Educator Accounts</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>

                  <tr>
                    <td>Unique URL</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Bulk Student and Group Upload</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Single Sign On</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Integration with SIS (such as PowerSchool, Aeries)</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Dedicated Account Management</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Local Opportunities Network</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <th style={{ paddingTop: '10px' }} colSpan="4">
                      Pricing and Payment
                    </th>
                  </tr>
                  <tr>
                    <td>Price (annual)</td>
                    <td className="feature-exists">Free</td>
                    <td className="feature-exists">$89</td>
                    <td className="feature-exists">$3.50 per student (minimum $525)</td>
                    <td className="feature-exists">Plans Starting at $5,000</td>
                  </tr>
                  <tr>
                    <td>Pay by Purchase Order</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">Credit Card Only</td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <th style={{ paddingTop: '10px' }} colSpan="4">
                      Professional Development Options
                    </th>
                  </tr>
                  <tr>
                    <td>Online Educator Lessons and Walk Throughs</td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td>Up to 3 Live Webinars</td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">
                      <i className="thumbs-outline">
                        <span className="sr-only">No</span>
                      </i>
                    </td>
                    <td className="feature-exists">$800</td>
                    <td className="feature-exists">
                      <i className="thumbs-up">
                        <span className="sr-only">Yes</span>
                      </i>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td></td>
                    <td className="basic-account ">
                      <a
                        href={`${siteUrl}/requestmanagement`}
                        className="btn btn-success btn-full"
                        style={{ marginBottom: '15px' }}
                        title="">
                        {this.btnText('Create Account')}
                      </a>
                    </td>
                    <td className="ed-account">
                      <Link
                        to={`${
                          props.match.params.state ? `/${props.match.params.state}` : ''
                        }/quote`}
                        className="btn btn-success btn-full"
                        style={{ marginBottom: '15px' }}
                        title="">
                        {this.btnText()}
                      </Link>
                    </td>
                    <td className="prem-ed-account">
                      <Link
                        to={`${
                          props.match.params.state ? `/${props.match.params.state}` : ''
                        }/quote`}
                        className="btn btn-success btn-full"
                        style={{ marginBottom: '15px' }}
                        title="">
                        {this.btnText()}
                      </Link>
                    </td>
                    <td className="prem-ed-account">
                      <Link
                        to={`${
                          props.match.params.state ? `/${props.match.params.state}` : ''
                        }/quote`}
                        className="btn btn-success btn-full"
                        style={{ marginBottom: '15px' }}
                        title="">
                        {this.btnText()}
                      </Link>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => {
    return {}
  },
  dispatch => {
    return {
      dispatch
    }
  }
)(PricingGrid)
